import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPaperPlane, FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { FiMail } from 'react-icons/fi';
import { Form } from '@unform/web';
import Input from '../../../../core/components/Forms/Input';
import { urlWebsite } from '../../../../../../config';

interface ICreateModule {
  lineData: Record<string, any>;
  projectHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule({
  lineData,
  projectHash
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();

  const key = uuid();

  const sendEmailTest = async (data) => {

    if (!data?.email) {
      addToast({ title: 'Insira um e-mail válido', type: 'error' })
    }

    try {
      const project = await api.get('/projects', { params: { where: { url: projectHash } } })


      await api.post(`/mailer-campaign-send-test/${lineData?._id?.toString()}`, { email: data?.email, imagePath: urlWebsite, website: project?.data?.rows?.[0]?.theme_data?.website_url });
      addToast({ title: 'Agendado com sucesso', type: 'success' });
      removeModal('confirm');
      await reloadSearchAll();
    }
    catch (err) {
      addToast({ title: 'Erro ao agendar', type: 'error' })
    }

  }


  const handleCreate = (): void => {
    const content = <><Form onSubmit={sendEmailTest}>
      <Input name='email' placeholder='E-mail' />
      <button className='greenButton2' >Enviar teste</button>
    </Form>
    </>;
    if (content) {
      const keyModal = addModal({ title: '', content, key, theme: "whiteModal" });
    }
  };

  const moduleCreate = (): JSX.Element => (
    lineData._id ? <button className="lineIcon" title='Enviar Teste' type="button" onClick={handleCreate}>
      <FiMail />
    </button> : <></>
  );

  return moduleCreate();
}
